/* Feb-2026 · Gold diagonal "New Title" ribbon rendered in the top-left
 * corner of a book cover.
 *
 * Rendered when any of these are true:
 *   - book.is_new_release === true (explicit admin flag)
 *   - book.published_at is within the last `windowDays` (default 30)
 *
 * Pure CSS — no images, ~1KB total. Sits under any absolutely-positioned
 * heat/content chips (which use `z-10`), so both can coexist.
 */
import React from 'react';

function _isRecent(iso, windowDays = 30) {
  if (!iso) return false;
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return false;
  return (Date.now() - then) < windowDays * 86400 * 1000;
}

export function shouldShowNewTitleRibbon(book, windowDays = 30) {
  if (!book) return false;
  if (book.is_new_release === true) return true;
  return _isRecent(book.published_at, windowDays);
}

export default function NewTitleRibbon({ label = 'New Title', size = 'sm' }) {
  const s = size === 'sm'
    ? { band: 'h-4 w-[130px] -translate-x-9 translate-y-3.5 text-[9px] tracking-[0.16em]',
        outer: 'h-14 w-14' }
    : { band: 'h-5 w-[160px] -translate-x-10 translate-y-4 text-[10.5px] tracking-[0.18em]',
        outer: 'h-16 w-16' };
  return (
    <div
      data-testid="book-card-new-title-ribbon"
      aria-label={label}
      className={`pointer-events-none absolute left-0 top-0 z-20 overflow-hidden ${s.outer}`}
    >
      <div
        className={`absolute left-0 top-0 -rotate-45 origin-top-left flex items-center justify-center font-semibold uppercase text-[#3d2900] shadow-[0_2px_6px_rgba(0,0,0,0.35)] ${s.band}`}
        style={{
          background: 'linear-gradient(135deg,#f5d76e 0%,#d4a531 55%,#b4842b 100%)',
          borderTop: '1px solid #f7e39a',
          borderBottom: '1px solid #8a6420',
        }}
      >
        {label}
      </div>
    </div>
  );
}
